import { OrderStatusType } from "../../utils/OrderStatusType";
import { ReturnStoreAddress } from "../../utils/helper";
import StoreDescription from "../Store/Store-Description";
const OrderStoreInfo = ({ orderDetail, refrencePage }: any) => {
  return (
    <>
      <div className="flex md:flex-row flex-col gap-2 ">
        <div className="w-full flex gap-6">
          <div className="rounded-md overflow-hidden h-auto md:w-20 w-20 relative">
            {orderDetail.store_data ? (
              <img
                src={`${orderDetail?.store_data?.[0]?.store_image?.base_url}${orderDetail?.store_data?.[0]?.store_image?.attachment_url}`}
                className="w-full h-auto object-cover mix-blend-multiply"
                alt=""
              />
            ) : (
              ""
            )}
          </div>
          <div>
            <h4 className="font-splekta text-2xl font-normal text-black">
              {orderDetail?.store_data
                ? orderDetail?.store_data?.[0]?.store_name
                : ""}
            </h4>
            <StoreDescription
              refrencePage="OrderDetail"
              store={orderDetail?.store_data?.[0]}
            />

            <div className="md:flex hidden justify-between">
              <p className="flex  text-base font-normal gap-1 items-center mb-2">
                <img src="/images/location-icon.svg" className="size-5" />
                {orderDetail?.store_data
                  ? ReturnStoreAddress(orderDetail?.store_data?.[0])
                  : ""}
              </p>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-between ">
          <p className="flex  text-base font-normal gap-1 items-start mb-2">
            <img src="/images/location-icon.svg" className="size-5" />
            {orderDetail?.store_data
              ? ReturnStoreAddress(orderDetail?.store_data?.[0])
              : ""}
          </p>
        </div>
        <div className=" flex md:flex-col flex-row flex-wrap justify-between">
          {/* <h4 className="md:text-lg textMd font-bold text-[#1466FA] text-right whitespace-nowrap"> */}
          <h4 className="md:text-lg textMd font-bold text-[#1466FA] text-left  max-w-full inline-block break-words word-flex-grow">
            {/* {getOrderId(orderDetail?.order_id)} */}

            {`Order #${orderDetail?.order_item_id}`}
          </h4>
          {/* <p className="md:text-lg textMd font-bold text-[#30C53E] text-right">
            {OrderStatusType(orderDetail?.order_status)}
          </p> */}
        </div>
      </div>
    </>
  );
};

export default OrderStoreInfo;
